import { AppView, PLATFORM_DESKTOP_SMALL, PLATFORM_OVERLAY_SMALL, PLATFORM_OVERLAY_EXTRASMALL } from "@gaming/srvg-classes-core";
import { MatchdayPickerLeagueView } from "../MatchdayPickerLeagueView";
import { ChunkIndicatorView } from "../ChunkIndicatorView";
import { LivescoreWidget } from "../../../widgets/View/VfWidget/LivescoreWidget";
import { TickerWidget } from "../../../widgets/View/VfWidget/TickerWidget";
import { VideoAreaView } from "../VideoAreaView";
import { ChunkAreaView } from "../ChunkAreaView";
import { LivetableLeagueWidget } from "../../../widgets/View/VfWidget/LivetableLeagueWidget";
import { TimelineWidget } from "../../../widgets/View/VfWidget/TimelineWidget";


/**
 * Main view class for the VFC cup view.
 */
export class LeagueView extends AppView {
    chunkIndicatorView: ChunkIndicatorView;
    livescoreWidget: LivescoreWidget;
    tickerWidget: TickerWidget;
    videoAreaView: VideoAreaView;
    chunkAreaView: ChunkAreaView;
    matchdayPickerLeagueView: MatchdayPickerLeagueView;

    constructor(options) {
        options = options || {};
        options.name = options.name || "cupView";
        options.selector = "#" + options.name;
        super(options);
        this.isExpanded = true;


        this.chunkIndicatorView = this.addSubView(new ChunkIndicatorView({}));

        this.livescoreWidget = null;
        if (srvg.widgets.enabled){
            // Livescore widget if it is enabled in configuration file
            if (srvg.widgets.widgets["livescore"].enabled) {
                this.livescoreWidget = this.addSubView(new LivescoreWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: "#LivescoreWidget",
                    // how many columns should be shown in livescore widget
                    numOfColumns: 4,
                    platform: PLATFORM_DESKTOP_SMALL
                }));
            }

            // (Cross match) ticker widget if it is enabled in configuration file
            if (srvg.widgets.widgets["ticker"].enabled) {
                this.tickerWidget = this.addSubView(new TickerWidget({
                    selector: "#CrossMatchTickerHead",
                    platform: PLATFORM_OVERLAY_SMALL,
                    goalEvent: true,
                    ownGoalEvent: true,
                    yellowCardEvent: false,
                    yellowRedCardEvent: true,
                    redCardEvent: true
                }));
            }
        }

        this.videoAreaView = this.addSubView( new VideoAreaView( {} ) );

        if (srvg.widgets.enabled) {
            // Timeline widget if it is enabled in configuration file
            if (srvg.widgets.widgets["timeline"].enabled) {
                this.videoAreaView.addSubView(new TimelineWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: "#eventtimelineWidget",
                    showAbbreviations: false,
                    platform: PLATFORM_OVERLAY_EXTRASMALL
                }));
            }

            // livetableLeague widget if it is enabled in configuration file
            if (srvg.widgets.widgets["livetableLeague"].enabled) {
                this.videoAreaView.addSubView(new LivetableLeagueWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: "#livetableWidget",
                    platform: PLATFORM_OVERLAY_EXTRASMALL,
                    form: true,
                    games: true,
                    showHeader: false
                }));
            }
        }

        // new subview for matchday picker
        this.matchdayPickerLeagueView = this.addSubView( new MatchdayPickerLeagueView({
            matchdayPickerLeagueView: true
        }));

        this.chunkAreaView = this.addSubView( new ChunkAreaView({
            chunkPickerView: true
        }));
    }

    // hide all elements that would still be shown after other elements are already enabled
    handleTimeoutEvent( event, provider ) {
        this.tickerWidget.hide(false);
        $('#eventtimelineWidget').css('display','none');
    }
}
